import { FC, useEffect } from 'react';
import { Slide as SlideType } from '@/eventConfig/types.ts';
import { useForm } from '@/form/useForm.ts';
import { useNavigation } from '@/navigation/NavigationContex.ts';
import { shouldUseBirthdateManualFlow } from '@/components/slides/BirthdateGate/birthdateFlow.ts';

interface BirthdateGateSlideProps {
  className?: string;
  slide: SlideType;
}

export const BirthdateGateSlide: FC<BirthdateGateSlideProps> = () => {
  const { getFieldValue } = useForm();
  const { gotoSlide } = useNavigation();

  useEffect(() => {
    const peselCheckResult = String(getFieldValue('peselCheckResult') ?? '');
    const pesel = String(getFieldValue('pesel') ?? '');
    const zaId = String(getFieldValue('za_id') ?? '');
    const birthdate = String(getFieldValue('birthdate') ?? '');

    if (shouldUseBirthdateManualFlow({ peselCheckResult, pesel, zaId, birthdate })) {
      gotoSlide('birthdateManual' as any);
      return;
    }

    gotoSlide('birthdate');
  }, [getFieldValue, gotoSlide]);

  return null;
};
